/** Serialize left-panel filter state for user_saved_views.filter_config. */
export function buildFilterConfig(state) {
  return {
    selectedCountySlugs: state.selectedCountySlugs,
    selectedMunicipalityIds: state.selectedMunicipalityIds,
    locationFilterMode: state.locationFilterMode,
    selectedDataTypes: state.selectedDataTypes,
    selectedStatuses: state.selectedStatuses,
    includeAllDates: state.includeAllDates,
    dateRange: { ...state.dateRange },
    activityDateMode: state.activityDateMode,
    dealSize: {
      acres: { ...state.dealSize.acres },
      units: { ...state.dealSize.units },
      density: { ...state.dealSize.density },
    },
    selectedCaseNatures: state.selectedCaseNatures,
  };
}

function sortedStrings(arr) {
  return [...(arr || [])].map(String).sort();
}

function normalizeDealField(field) {
  return {
    operator: field?.operator || '',
    value: field?.value === null || field?.value === undefined ? '' : String(field.value),
  };
}

/** Normalize filter config for stable equality checks. */
export function normalizeFilterConfig(config) {
  if (!config) return null;
  return {
    selectedCountySlugs: sortedStrings(config.selectedCountySlugs),
    selectedMunicipalityIds: sortedStrings(config.selectedMunicipalityIds),
    locationFilterMode: config.locationFilterMode || 'counties',
    selectedDataTypes: sortedStrings(
      (config.selectedDataTypes || []).filter((item) => item !== 'SELECT_ALL'),
    ),
    selectedStatuses: sortedStrings(config.selectedStatuses),
    includeAllDates: config.includeAllDates !== false,
    dateRange: {
      from: config.dateRange?.from || '',
      to: config.dateRange?.to || '',
    },
    activityDateMode: config.activityDateMode || 'overlap',
    dealSize: {
      acres: normalizeDealField(config.dealSize?.acres),
      units: normalizeDealField(config.dealSize?.units),
      density: normalizeDealField(config.dealSize?.density),
    },
    selectedCaseNatures: sortedStrings(config.selectedCaseNatures),
  };
}

export function filterConfigsEqual(a, b) {
  if (!a || !b) return false;
  return JSON.stringify(normalizeFilterConfig(a)) === JSON.stringify(normalizeFilterConfig(b));
}
